module.exports = __webpack_public_path__ + "static/GodRuneMasterA-4d3e0e4bdc768b890b88cf5d5d30c53f.gif";